
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"100","viewBox":"0 0 104.491 128.599"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M68.321 24.113a12.057 12.057 0 10-12.057-12.056 12.057 12.057 0 0012.057 12.056zM28.557 79.742l-3.717 8.671H8.038a8.038 8.038 0 000 16.076h19.454a12.031 12.031 0 0011.08-7.307l2.208-5.154-2.68-1.583a23.919 23.919 0 01-9.542-10.7zm67.9-23.48H85.393l-6.545-13.376a24.1 24.1 0 00-15.518-12.8l-17.854-5.31a24.011 24.011 0 00-20.305 4.305l-9.964 7.638a8.037 8.037 0 109.78 12.761l9.969-7.638A7.822 7.822 0 0141.3 40.3l3.7 1.1-9.413 21.947a16.118 16.118 0 006.606 20.173l21.345 12.6-6.9 22.036a8.037 8.037 0 1015.34 4.8l7.947-25.384a12.107 12.107 0 00-5.435-13.658l-15.382-9.078 7.864-19.662 5.091 10.406a12.131 12.131 0 0010.828 6.754h13.562a8.036 8.036 0 100-16.073z","fill":"#63cdf5"}})])
          )
        }
      }
    